// AuthorizePage — 게이트웨이 OIDC 인가(authorize) 처리 화면(협업 SSO 연결 흐름).
import { useEffect, useState } from 'react';

// OIDC SPA 브리지: MM/NC가 이 경로로 리다이렉트 → localStorage JWT로 본인 인증 →
// POST /api/oauth/authorize 로 1회용 code 발급받아 MM/NC redirect_uri로 돌려보낸다.
export default function AuthorizePage() {
  const [err, setErr] = useState('');

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const body = {
      client_id: qs.get('client_id'),
      redirect_uri: qs.get('redirect_uri'),
      scope: qs.get('scope') || 'openid',
      state: qs.get('state'),
      nonce: qs.get('nonce'),
      code_challenge: qs.get('code_challenge'),
      code_challenge_method: qs.get('code_challenge_method'),
    };
    if (!body.client_id || !body.redirect_uri) {
      setErr('잘못된 인증 요청입니다.');
      return;
    }
    const toLogin = () => {
      const next = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.replace(`/login?next=${next}`);
    };
    const token = localStorage.getItem('token');
    if (!token) { toLogin(); return; }

    const API = process.env.REACT_APP_API_URL || '';
    fetch(`${API}/api/oauth/authorize`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body),
    })
      .then(async (r) => {
        if (r.status === 401) { toLogin(); return null; }
        const d = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(d.detail || '인증 연동에 실패했습니다.');
        return d;
      })
      .then((d) => { if (d && d.redirect) window.location.replace(d.redirect); })
      .catch((e) => setErr(String(e.message || e)));
  }, []);

  return (
    <div style={S.wrap}>
      <div style={S.card} aria-live="polite">
        {err ? (
          <>
            <h3 style={S.title}>로그인 연동 오류</h3>
            <p style={S.err} role="alert">{err}</p>
            <a href="/" style={S.link}>홈으로</a>
          </>
        ) : (
          <>
            <h3 style={S.title}>로그인 연동 중</h3>
            <p style={S.muted}>요청을 확인하고 이동합니다.</p>
          </>
        )}
      </div>
    </div>
  );
}

const S = {
  wrap: { display: 'flex', minHeight: 'var(--gw-app-h, 100dvh)', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--gw-font)', background: '#f5f5f5', padding: '16px', boxSizing: 'border-box' },
  card: { width: '100%', maxWidth: '380px', background: 'white', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,.1)', padding: '32px 24px', textAlign: 'center', color: '#334155', boxSizing: 'border-box' },
  title: { margin: '0 0 12px', fontSize: '18px', color: '#1f2937' },
  muted: { margin: 0, color: '#6b7280', fontSize: '14px' },
  err: { color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '10px', padding: '12px', margin: '0 0 16px', fontSize: '14px', lineHeight: 1.6 },
  link: { color: '#2563eb', fontSize: '14px', fontWeight: 700 },
};
